
import notificator from "@/services/notificator";

export default {
  install(Vue) {
    Vue.$notificator = notificator;
    Vue.prototype.$notificator = notificator;
    window.notificator = notificator;
  }
};
